var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 8,
    height: 7,
    fill: "#36C8F6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 14,
    width: 8,
    height: 7,
    fill: "#36C8F6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 3,
    width: 8,
    height: 7,
    fill: "#36C8F6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 14,
    width: 8,
    height: 7,
    rx: 3.5,
    fill: "#011367"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 3.5H4C3.72386 3.5 3.5 3.72386 3.5 4V9.5C3.5 9.77614 3.72386 10 4 10H9.5C9.77614 10 10 9.77614 10 9.5V4C10 3.72386 9.77614 3.5 9.5 3.5ZM4 2C2.89543 2 2 2.89543 2 4V9.5C2 10.6046 2.89543 11.5 4 11.5H9.5C10.6046 11.5 11.5 10.6046 11.5 9.5V4C11.5 2.89543 10.6046 2 9.5 2H4Z",
    fill: "#36C8F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 14H4C3.72386 14 3.5 14.2239 3.5 14.5V20C3.5 20.2761 3.72386 20.5 4 20.5H9.5C9.77614 20.5 10 20.2761 10 20V14.5C10 14.2239 9.77614 14 9.5 14ZM4 12.5C2.89543 12.5 2 13.3954 2 14.5V20C2 21.1046 2.89543 22 4 22H9.5C10.6046 22 11.5 21.1046 11.5 20V14.5C11.5 13.3954 10.6046 12.5 9.5 12.5H4Z",
    fill: "#36C8F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 3.5H14.5C14.2239 3.5 14 3.72386 14 4V9.5C14 9.77614 14.2239 10 14.5 10H20C20.2761 10 20.5 9.77614 20.5 9.5V4C20.5 3.72386 20.2761 3.5 20 3.5ZM14.5 2C13.3954 2 12.5 2.89543 12.5 4V9.5C12.5 10.6046 13.3954 11.5 14.5 11.5H20C21.1046 11.5 22 10.6046 22 9.5V4C22 2.89543 21.1046 2 20 2H14.5Z",
    fill: "#36C8F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 17.25C14 19.0449 15.4551 20.5 17.25 20.5C19.0449 20.5 20.5 19.0449 20.5 17.25C20.5 15.4551 19.0449 14 17.25 14C15.4551 14 14 15.4551 14 17.25ZM17.25 12.5C14.6266 12.5 12.5 14.6266 12.5 17.25C12.5 19.8734 14.6266 22 17.25 22C19.8734 22 22 19.8734 22 17.25C22 14.6266 19.8734 12.5 17.25 12.5Z",
    fill: "#011367"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryIcon);
export default __webpack_public_path__ + "static/media/category-icon.219cbda510c9e1ad516b697e7a495df0.svg";
export { ForwardRef as ReactComponent };